import React from "react";
import "./whoWe.css";
import experience from "../../assets/experience.png";
import { Dots } from "react-dot-patterns";
import AutoTyping from "react-auto-typing";
import { TypeAnimation } from "react-type-animation";
const WhoWe = () => {
  const textRef = { __html: "Who&nbsp;<span>We</span>&nbsp;are?" };

  return (
    <div className="whoWe-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>

      <div className="whoWe-details">
        <div
          className="row align-items-center "
          style={{ justifyContent: "space-between" }}
        >
          <div className="col-12 ">
            <div className="who-we-infos">
              <h2>
                Who We <span>Are?</span>
              </h2>
              <p className="my-4">
                At Soori Corporation, we are dedicated to being a catalyst for
                your business innovation. Our mission is to help organizations
                unlock their full potential and drive value through cutting-edge
                software engineering services across diverse sectors, including
                supply chain, healthcare, FinTech, IoT, and beyond.We specialize
                in designing and delivering high-quality, stable, scalable, and
                functional digital solutions that are tailored to meet your
                unique needs. Our team of skilled developers not only brings
                these solutions to life but also shares their extensive
                knowledge and expertise to empower your business.
              </p>
              {/* <div className="mt-10x">
                <a className="link-btn btn link-btn--primary" href="/about-us">
                  <span>Contact Us</span>
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWe;
